import { SettingsIdValues } from "@octopusdeploy/octopus-server-client";
import { EditSettingsPage } from "~/areas/configuration/components/Settings/EditSettingsPage";
export function RetentionPoliciesSettingsPage() {
    return <EditSettingsPage settingId={SettingsIdValues.RetentionPolicies}/>;
}
